import { TextStyle } from '@client/style/TextStyles';
import React from 'react';
import styled from 'styled-components';
import List from '@client/assets/svgs/list.svg';

const IndexNav = styled.div<{ $fg?: string }>`
	${TextStyle.size('p4')}
	${TextStyle.family('title')}
	${TextStyle.weight('bold')}
	padding-top: 80px;
	text-align: right;
	display: flex;
	align-items: center;
	line-height: initial;
	justify-content: flex-end;
	color: ${props => props.$fg};
	z-index: 1;
`;

const SVGIcon = styled.div`
	display: flex;
	align-items: center;

	svg {
		margin-left: 20px;
		color: inherit;
	}
`;

const Clickable = styled.button`
	display: flex;
	align-items: center;
	color: inherit;
`;

export default function IndexMenuButton({ onClick, bgColor }: { onClick: () => void; bgColor: any }) {
	return (
		<IndexNav $fg={bgColor?.contrastColor}>
			<Clickable
				onClick={() => {
					onClick();
				}}
			>
				Oversigt
				<SVGIcon>
					<List />
				</SVGIcon>
			</Clickable>
		</IndexNav>
	);
}
